import { render, staticRenderFns } from "./FloatingBanner.vue?vue&type=template&id=c52856aa&"
import script from "./FloatingBanner.vue?vue&type=script&lang=ts&"
export * from "./FloatingBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports